import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setExercicioConsultaPlanoPlurianual: ['exercicio'],
    setAdministracoesConsultaPlanoPlurianual: ['administracoes'],
    setIndicadoresConsultaPlanoPlurianual: ['indicadores'],
    limpaFiltroConsultaPlanoPlurianual: [],
    receberFiltroConsultaPlanoPlurianual: ['filtroRecebido'],
})

const INITIAL_STATE = {
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    administracoes: [],
    indicadores: [],
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setAdministracoes = (state = INITIAL_STATE, action) => {
    return { ...state, administracoes: action.administracoes }
}

const setIndicadores = (state = INITIAL_STATE, action) => {
    return { ...state, indicadores: action.indicadores }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_CONSULTA_PLANO_PLURIANUAL]: setExercicio,
    [Types.SET_ADMINISTRACOES_CONSULTA_PLANO_PLURIANUAL]: setAdministracoes,
    [Types.SET_INDICADORES_CONSULTA_PLANO_PLURIANUAL]: setIndicadores,
    [Types.LIMPA_FILTRO_CONSULTA_PLANO_PLURIANUAL]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_PLANO_PLURIANUAL]: receberFiltro,
})
